
<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 lg11  align-self-center>
        <v-card elevation="0">
          <v-layout>
            <v-flex>
              <v-dialog v-model="value" width="900px" v-if="turtleimg" >
                <v-card >
                <v-img  width="900"
                  contain :src="mediaURL + turtleimg" ></v-img>
                </v-card>
              </v-dialog>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex px-12 align-self-center md6>
              <v-layout wrap justify-center>
                <v-flex py-5 align-self-center class="heading-decorate">
                  <span style="font-family:poppins-semibold ;font-size:20px " class="text-uppercase">
                    {{ reportData.purpose + " Details" }}</span
                  >
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex md12 align-self-start text-left @click="big">
                  <v-img  height="210px"
                                contain v-if="turtleimg" :src="mediaURL + turtleimg"></v-img>
                  <v-img v-if="!turtleimg"
                                height="210px"
                                contain
                                src="../../assets/logos/sample.png"
                               
                              >       
                </v-img>
                </v-flex>
                <v-flex md12 align-self-center style="font-family:poppins-regular " class="label-decorate">
                 
                  <v-layout wrap>
                    <v-flex py-3 lg3 align-self-center>
                      <span class="text_head">Turtle</span>
                    </v-flex>
                    <v-flex lg3></v-flex>
                    <v-flex
                      lg6
                      align-self-center
                      class="text-decorate text-capitalize"
                      >{{ turtlename }}</v-flex
                    >
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout wrap>
                    <v-flex py-3 lg3 align-self-center>
                      <span class="text_head">Report Date</span>
                    </v-flex>
                    <v-flex lg3></v-flex>
                    <v-flex
                      lg6
                      align-self-center
                      class="text-decorate text-capitalize"
                    >
                      {{ DateFormatted(reportData.createddate) }}</v-flex
                    >
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout wrap>
                    <v-flex py-3 lg3 align-self-center class="text_head">Purpose</v-flex>
                    <v-flex lg3></v-flex>
                    <v-flex
                      lg6
                      align-self-center
                      class="text-decorate text-capitalize"
                    >
                      {{ reportData.purpose }}</v-flex
                    >
                  </v-layout>
                  <v-divider></v-divider>

                  <v-layout wrap>
                    <v-flex py-3 lg3 align-self-center class="text_head">Nearest City</v-flex>
                    <v-flex lg3></v-flex>
                    <v-flex
                      lg6
                      align-self-center
                      class="text-decorate text-capitalize"
                      >{{ reportData.nearestcity }}</v-flex
                    >
                  </v-layout>
                  <v-divider></v-divider>

                  <v-layout wrap>
                    <v-flex py-3 lg3 align-self-center class="text_head">State</v-flex>
                    <v-flex lg3></v-flex>
                    <v-flex
                      lg6
                      align-self-center
                      class="text-decorate text-capitalize"
                      >{{ reportData.state }}</v-flex
                    >
                  </v-layout>
                  <v-divider></v-divider>

                  <v-layout wrap>
                    <v-flex py-3 lg3 align-self-center class="text_head">Condition</v-flex>
                    <v-flex lg3></v-flex>
                    <v-flex
                      lg6
                      align-self-center
                      class="text-decorate text-capitalize"
                      >{{ reportData.condition }}</v-flex
                    >
                  </v-layout>
                  <v-divider></v-divider>

                  <v-layout wrap>
                    <v-flex py-3 lg3 align-self-center class="text_head">Life Stage</v-flex>
                    <v-flex lg3></v-flex>
                    <v-flex
                      lg6
                      align-self-center
                      class="text-decorate text-capitalize"
                      >{{ reportData.lifestage }}</v-flex
                    >
                  </v-layout>
                  <v-divider></v-divider>

                  <v-layout wrap>
                    <v-flex py-3 lg3 align-self-center class="text_head">Comment</v-flex>
                    <v-flex lg3></v-flex>
                    <v-flex
                      lg6
                      align-self-center
                      class="text-decorate text-none"
                      >{{ reportData.comment }}</v-flex
                    >
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md6 px-12 px-sm-12 px-md-0  pr-md-12>
          <Locate :id="this.id"/>
            </v-flex>
          </v-layout>
          
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import Locate from "./Locate"

export default {
  data() {
    return {
      value:false,
      dialoge:false,
      turtlename: "",
      turtleimg: "",
      reportData: [],
      lat: 0,
      lon: 0,
      rescueData: [],
      reslat: 0,
      reslon: 0,
    };
  },
  components:{
    Locate
  },
  props: ["id"],
  mounted() {
    this.getData();
  },
  methods: {
    big(){
         this.value = true;
        
    },
    DateFormatted(params) {
      return params ? moment(params).format("DD-MM-Y") : "";
      // return params ? moment(params).format("DD-MM-Y,h:mm:ss a") : "";
    },
    getData() {
      axios({
        method: "GET",
        url: "report/get",
        params: { id: this.id },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          this.reportData = response.data.data;
          this.turtlename = response.data.data.turtle.name;
          this.turtleimg = response.data.data.image;

          this.lat = response.data.data.location[1];
          this.lon = response.data.data.location[0];
        }
      });
    },
  },
};
</script>
<style>
.text_head{
  font-family: poppins-semibold;
}
</style>